<template>
  <e-status-badge
    :status="options ? context.model : context.model === true"
    :type="badgeType"
    :true-label="trueLabel"
    :false-label="falseLabel"
    :options="options"
  />
</template>
<script>
import { EStatusBadge } from '@/views/components'

export default {
  components: { EStatusBadge },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    /**
     * yesNo | activeInactive | options
     * activeInactive: badge com texto Ativo/Inativo
     * yesNo: badge com texto Sim/Não
     * options: segue o formato de options abaixo
     */
    badgeType() {
      return (
        this.context?.attributes['badge-type'] ||
        this.context?.attributes?.badgeType ||
        'activeInactive'
      )
    },
    trueLabel() {
      return (
        this.context?.attributes['true-label'] || this.context?.attributes?.trueLabel || undefined
      )
    },
    falseLabel() {
      return (
        this.context?.attributes['false-label'] || this.context?.attributes?.falseLabel || undefined
      )
    },
    options() {
      return this.context?.options
    },
  },
}
</script>
